import type { DiffMode } from "./search-params";

// Remember the last search object per top-level view so TopBar links
// can switch routes without wiping Chart compare or Views URL state.

export interface CompareSearchInput {
  items?: string;
  baseline?: string;
  view?: "diff" | "single";
  diffMode?: DiffMode;
  pair?: string;
}

export interface VersionsSearchInput {
  projects?: string;
  namespaces?: string;
  view?: "chart-updates-available";
  project?: string;
}

let lastCompareSearch: CompareSearchInput = {};
let lastVersionSearch: VersionsSearchInput = {};

export function rememberCompareSearch(search: CompareSearchInput): void {
  lastCompareSearch = search;
}

export function rememberVersionSearch(search: VersionsSearchInput): void {
  lastVersionSearch = search;
}

export function getLastCompareSearch(): CompareSearchInput {
  return lastCompareSearch;
}

export function getLastVersionSearch(): VersionsSearchInput {
  return lastVersionSearch;
}
